export const mapWorkingTimeDto = (dto) => ({
    id: dto.id,
    userId: dto.user_id,
    validFrom: dto.valid_from,
    validUntil: dto.valid_until,
    weekday: dto.weekday,
    expectedHours: dto.expected_hours,
});
